class Pdp_kitSection {
    constructor() {
        if(!document.querySelector('.what-you-get-in-the-kit-js')) return
        this.initSlider();
    }
    initSlider = () => {
        let element = document.querySelector('.what-you-get-in-the-kit-js .swiper')
        const blockSlider = new Swiper(element, {
            slidesPerView: 3,  
            spaceBetween: 20,
            breakpoints: {
                325: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 3,  
                    spaceBetween: 20
                }     
            }
        });      
    }
}
new Pdp_kitSection;